module.exports = __webpack_public_path__ + "img/02.11a993c4.jpg";